import { useCallback } from 'react';

import META from '~/hooks/events/useTrackSwitchedWorkspace.meta';
import { usePluginAnalytics } from '~/hooks/usePluginAnalytics';

export type TrackSwitchedWorkspaceParams = {
  workspace_id: string;
};

export const useTrackSwitchedWorkspace = () => {
  const { track, setGlobalEventProps } = usePluginAnalytics();

  const trackSwitchedWorkspace = useCallback(
    (params: TrackSwitchedWorkspaceParams) => {
      setGlobalEventProps({ workspaceId: params.workspace_id });
      track(META.name, params);
    },
    [setGlobalEventProps, track],
  );

  return { trackSwitchedWorkspace };
};
